import React, { useState } from "react";
import RadioOptionList from "../dashboard/RadioOptionList";
import { useSelector } from "react-redux";
import { v4 as uuid } from 'uuid';
import { useTranslation } from "react-i18next";


export default function Popover(prop) {
  const allProjectData = prop.type;
  const { dashboardTilesStatus } = prop;

  var display = "statusKey";
  var uniqueVar = "statusKey";
  const generatedId = uuid();

  const { t } = useTranslation();
  const translate = t;
  return (
   
      <div className="inner-popover">
        <div className="flex">
          <div className="left-block" role="radiogroup" aria-labelledby={"heading_"+generatedId}>
          <h4 id={"heading_"+generatedId}>Select Status</h4>
            {/* <span className="choose-option">Choose any 6 option at a time</span> */}

            <RadioOptionList
              taskTypes={allProjectData}
              parameterToShow={display}
              display={true}
              defaultSelected={prop.defSelected}
              parmToUse={uniqueVar}
              uniqueIDS={prop.uniqueId}
              use="projectCount"
            />
          </div>
          <div className="right-box-block">
            <div className="outer-bg flex">
            {dashboardTilesStatus.map((data,index) => (
              <div
              className={
                index ===prop.index 
                ? "department-box-list active"
                  : "department-box-list"
              }
            >
              <div className="inner-box">
                <span>{index+1}.</span>
                <strong>{data?.shortLabel}</strong>
              </div>
            </div>              
              ))}
            </div>
          </div>
        </div>
      </div>
  
  );
}
